import { render, staticRenderFns } from "./CrmNotificationList.vue?vue&type=template&id=09c77632&"
import script from "./CrmNotificationList.vue?vue&type=script&lang=js&"
export * from "./CrmNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports